import React, { useEffect, useState } from "react";
import Tree from "react-d3-tree";
import { useCenteredTree } from "./helper";
import "./style.css";
import Title from '../product/add_product/title';
import server from '../functions/server';
import $ from 'jquery';
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Paper, Button, ListItem, TextField } from '@material-ui/core';
import { TableRow, TableHeaderCell, TableHeader, TableCell, Input, } from 'semantic-ui-react';

const containerStyles = {
  width: "100vw",
  height: "100vh",
};

const getWeekNumber = (d) => {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1)/7);
  return weekNo;
}

const getWeekRange = (date = new Date()) => {
  const weekNumber = getWeekNumber(date);
  const day = date.getDay();
  const diffToMonday = (day === 0 ? -6 : 1) - day; 
  const monday = new Date(date);
  monday.setDate(date.getDate() + diffToMonday);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return `Week - ${weekNumber} (${monday.toLocaleDateString()} to ${sunday.toLocaleDateString()})`;
}

const buildTree = (data) => {
  const idMap = {};
  data.forEach(item => {
    idMap[item.customerId] = {
      id: Number(item.customerId),
      name: item.customerName,
      children: [null, null],
      isEmpty: false,
    };
  });

  data.forEach(item => {
    if (item.parentId !== "0" && idMap[item.parentId]) {
      const pos = item.position === "Left" ? 0 : 1;
      idMap[item.parentId].children[pos] = idMap[item.customerId];
    }
  });

  Object.values(idMap).forEach(node => {
    node.children = node.children.map(child =>
      child ? child : { name: "", isEmpty: true, children: [] }
    );
  });

  return data
    .filter(item => item.parentId === "0")
    .map(item => idMap[item.customerId]);
};

const flatData = [
  
]

const renderNodeWithCustomEvents = ({
  nodeDatum,
  toggleNode,
  handleNodeClick
}) => (
  <g>
    <circle
      r="15"
      fill={nodeDatum.isEmpty ? "#eee" : "#55ACEE"}
      stroke="#132880"
      strokeWidth="1"
      onClick={ () => handleNodeClick(nodeDatum)}
    />
    {!nodeDatum.isEmpty && (
      <text strokeWidth="1" x="20" onClick={toggleNode}>
        {`CUS - ${nodeDatum.id}`}
        {nodeDatum.name ? ` (${nodeDatum.name})` : "---"}
      </text>
    )}
  </g>
);

export default function CustomerTree({ shop }) {
  const [parentData, setParentData] = useState({});
  const [actionModal, setActionModal] = useState(false);
  const [points, setpoints ] = useState({});
  const [selectedParent, setSelectedParent] = useState(null);
  const [data, setData] = useState(flatData);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [limit, setLimit] = useState(0);
  const [hideButton, setHideButton] = useState(true);
  

  useEffect(() => {
    const getAllCustomers = () => {
      let url = server() + '/customertree/get.php';
      let postData = { id: shop.id };
      $.ajax({
        url: url,
        data: postData, type: 'POST',
      }).done((data) => {
        let out = [];
        try {
          out = JSON.parse(data);
          if (Array.isArray(out) && out.length > 0) {
            const normalized = out.map(item => ({
              ...item,
              id: Number(item.id),
              customer_reference_id: Number(item.customer_reference_id ?? 0),
              customer_reference_no: Number(item.customer_reference_no ?? 0)
            }));
            setData(normalized);
          }
        } catch (e) {
          // Optionally handle error
        }
      });
    }
    getAllCustomers();
  }, []);

  const handleNodeClick = (nodeDatum) => {
    setParentData(nodeDatum);
    let url = server() + '/customertree/getpoints.php'; 
    let postData = { id: nodeDatum.id, date: new Date().toISOString().split('T')[0] };
    $.ajax({
      url: url,
      data: postData,
      type: 'POST',
    }).done((res) => {
      try {
        res = JSON.parse(res);
        res = res[0];
        let hideButton = false;
        let paymentAmount = 0;
        let leftPoint = convertIntoNumber(res["left_points"]);
        let rightPoint = convertIntoNumber(res["right_points"]);
        res["o_left_points"] = convertIntoNumber(res["left_points"]);
        res["o_right_points"] = convertIntoNumber(res["right_points"]);
        if (leftPoint <= 50 && rightPoint <= 50) {
          hideButton = true;
        }
        let totalPaidAmount = convertIntoNumber(res["total_paid_amount"]);
        leftPoint = leftPoint - totalPaidAmount;
        rightPoint = rightPoint - totalPaidAmount;
        let limit = 0;
        if (leftPoint <= rightPoint) {
          paymentAmount = leftPoint;
          limit = paymentAmount;
        }
        if (rightPoint <= leftPoint) {
          paymentAmount = rightPoint;
          limit = paymentAmount;
        }
        if (paymentAmount > 5000) {
          paymentAmount = 5000;
        }
        res["left_points"] = leftPoint;
        res["right_points"] = rightPoint;
        setPaymentAmount(paymentAmount);
        setLimit(limit);
        setpoints(res);
        setActionModal(true);
        setHideButton(hideButton);
      } catch (error) {
        
      }
    });
  };

  const [translate, containerRef] = useCenteredTree();
  const tree = buildTree(data);

  const convertIntoNumber = (value) => {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  const changePaymentAmount = (value) => {
    if (value > 5000) {
      alert(`Your maximum limit is : 5000`);
      return;
    }
    if (limit < value) {
      alert(`You are not allow to pay more then ${limit} INR`);
      return;
    }
    setPaymentAmount(value)
  }

  const payment = () => {
    if (paymentAmount < 50) {
      alert("You are not allow to pay below 50 INR");
      return;
    }
    let leftPoint = convertIntoNumber(points["o_left_points"]);
    let rightPoint = convertIntoNumber(points["o_right_points"]);
    if (leftPoint <= 50 && rightPoint <= 50) {
      alert("you are not allow to pay!!!");
      return;
    }
    const userConfirmed = window.confirm("Are you sure you want to proceed with the payment?");
    if (!userConfirmed) {
      return; // stop if user clicks Cancel
    }
    let url = server() + '/statements/addreceipt.php'; 
    let postData = { id: shop.id, customerId: parentData.id, amount: paymentAmount, timestamp: null };
    $.ajax({
      url: url,
      data: postData,
      type: 'POST',
    }).done((res) => {
      try {
        if (res == 1) {
          alert("Payment Success");
          setActionModal(false);
        } else {
          alert("Payment Failed");
        }
      } catch (error) {
        alert("Payment Failed");
      }
    });
  }

  return (
    <div>
      <Title shopDetails={[]} shopId={1} title={"UNIQSOFTS - Customer Tree"} menu={true} />
          <center>
          <br/>
            <b style={{ fontSize: 16 }}>{getWeekRange()}</b>
          </center>
          <div style={containerStyles} ref={containerRef}>
          
            {tree.length > 0 ? (
              <Tree
                data={tree}
                translate={translate}
                renderCustomNodeElement={(rd3tProps) =>
                  renderNodeWithCustomEvents({ ...rd3tProps, handleNodeClick })
                }
                orientation="vertical"
                separation={{ siblings: 2, nonSiblings: 1 }}
              />
            ) : (
              <div>No customer data available.</div>
            )}
          </div>
          <Dialog
            maxWidth={"sm"}
            open={actionModal}
            onClose={() => setActionModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
          >
        <DialogTitle>Point System</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <table style={{ width: '100%', borderColor: "#BFBFBF" }} border={1}>
              <tr>
                <th><b>Name</b></th>
                <th colSpan={2}>{parentData.name}</th>
              </tr>
              <tr>
                <th><b>Profile Id</b></th>
                <th colSpan={2}>{"CUS - "+parentData.id}</th>
              </tr>
              <tr>
                <th><b>Total User Count</b></th>
                <th colSpan={2}>{((convertIntoNumber(points.o_left_points) + convertIntoNumber(points.o_right_points))/50)}</th>
              </tr>
              <tr>
                <th style={{ width: "50%" }}><b style={{ color: "#55ACEE" }}>Title</b></th>
                <th style={{ width: "25%" }}><b style={{ color: "#55ACEE" }}>Left</b></th>
                <th style={{ width: "25%" }}><b style={{ color: "#55ACEE" }}>Right</b></th>
              </tr>
              <tr>
                <th><b>Referral</b></th>
                <th>{convertIntoNumber(points.o_left_points) / 50}</th>
                <th>{convertIntoNumber(points.o_right_points) / 50}</th>
              </tr>
              <tr>
                <th><b>Previous Matched Point</b></th>
                <th>{points.total_paid_amount}</th>
                <th>{points.total_paid_amount}</th>
              </tr>
              <tr>
                <th><b>Previous Paid</b></th>
                <th colSpan={2}>{points.total_paid_amount} INR</th>
              </tr>
              {/* <tr>
                <th><b>Previous Week Balance Points</b></th>
                <th>{convertIntoNumber(points.o_left_points) - convertIntoNumber(points.new_left_members_after_date)}</th>
                <th>{convertIntoNumber(points.o_right_points) - convertIntoNumber(points.new_left_members_after_date)}</th>
              </tr>
              <tr>
                <th><b>Current Week Balance Points</b></th>
                <th>{points.new_left_members_after_date}</th>
                <th>{points.new_right_members_after_date}</th>
              </tr> */}
              <tr>
                <th><b>Total Balance Points</b></th>
                <th>{points.left_points}</th>
                <th>{points.right_points}</th>
              </tr>
              <tr>
                <th><b>Matched Point</b></th>
                <th colSpan={2}>{points.left_points}</th>
              </tr>
              <tr>
                <th><b>Payment Amount</b></th>
                <th><Input type="number" fluid onChange={ (event) => changePaymentAmount(event.target.value) } value={paymentAmount} /></th>
                <th><Button onClick={payment} style={{ backgroundColor: "#55ACEE", color: "white" }} disabled={hideButton} fullWidth>PAY</Button></th>
              </tr>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setActionModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
